module.exports = __webpack_public_path__ + "static/media/logo_azul.d14bf1c0.png";